module.exports = __webpack_public_path__ + "static/media/new.60d2117e.jpg";